import * as type from './action-types';

export const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_VALIDATION_ERRORS:
      let errors = typeof action.payload.errors[0].detail.errors !== 'undefined'
        ? action.payload.errors[0].detail.errors : {};
      return Object.assign({}, errors);

    case type.CLEAR_VALIDATION_ERRORS:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/validation-errors/reducer.js
 **/